import * as React from "react";
import { Link } from "react-router-dom";
import { ListItem, ListItemText, Divider } from "@mui/material";
import CcpAdminLinks from "./inc/CcpAdminLinks";
import CcpSchoolLinks from "./inc/CcpSchoolLinks";
import CcpDistrictLinks from "./inc/CcpDistrictLinks";
import TechPrepAdminLinks from "./inc/TechPrepAdminLinks";
import TechPrepStaffLinks from "./inc/TechPrepStaffLinks";
import TechPrepCoordinatorLinks from "./inc/TechPrepCoordinatorLinks";
import TechPrepInstructorLinks from "./inc/TechPrepInstructorLinks";
import { useTheme } from "@mui/material/styles";
import { useAuth } from "../../config/AuthContext";

const MainLinks = () => {
  const theme = useTheme();
  const { currentUser } = useAuth();
  const userTypes = currentUser?.userTypes || {};

  return (
    <React.Fragment>
      <ListItem sx={{ mt: 2 }}>
        <Link to="/Dashboard">
          <ListItemText
            primary="Dashboard"
            sx={{ color: theme.palette.text.primary }}
          />
        </Link>
      </ListItem>
      <Divider />
      {userTypes.admin && <TechPrepAdminLinks />}
      {userTypes.staff && <TechPrepStaffLinks />}
      {userTypes.coordinator && <TechPrepCoordinatorLinks />}
      {userTypes.instructor && <TechPrepInstructorLinks />}
      {currentUser?.ccpAdminFlag && <CcpAdminLinks />}
      {currentUser?.ccpSchoolFlag && <CcpSchoolLinks />}
      {currentUser?.ccpDistrictFlag && <CcpDistrictLinks />}
    </React.Fragment>
  );
};

export default MainLinks;
